module.exports = __webpack_public_path__ + "4d6bb0ca04a6bf53af51ddc3f43c29e2.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/cell-shapes.svg
// module id = 817
// module chunks = 0